<template>
    <div class="tax-details-vue">
      <!-- #BR#98 Mbeng 9/06/2025 For ICMMU Tax details components/TaxDetails -->
       <!-- Header Section -->
       <Header class="responsive-bar">
         <template v-slot:title>
           {{ $t("tax-details") }}
         </template>
       </Header>
     
      
        <!-- Form Section -->
         <div class="bg-gray-50 shadow rounded-md min-h-screen max-w-3xl m-auto sm:mt-5">
         <ValidationObserver ref="observer">
         <div v-if="!loadingCountries">
           <div class="max-w-3xl mx-auto min-h-screen py-10">
             <div class="flex justify-between"><h3 class="py-5 text-lg leading-6 font-medium text-gray-900">{{ $t('tax-details') }}</h3></div>
             <p class="text-gray-600 mb-6">{{ $t('we-are-required-to-collect-tax-residency') }}</p>

             <div  class="text-sm leading-5 pt-4 rounded">
                <label>
                  {{ $t("country-of-residence") }}
                </label>
                <ValidationProvider>
                  <input
                    type="text"
                    v-model="form.pid_country"
                    disabled
                    class="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </ValidationProvider>
              </div>
   
             <div v-for="field in visibleFields" :key="field.key" class="text-sm leading-5 pt-4">
               
             <div v-if="field.kind === 'select'">
               <label>{{ checkLabel(field.label) }}
                <span v-if="getValidationRules(field.key).includes('required')" class="text-red-500">*</span>
               </label> 
               <ValidationProvider  :name="field.label" :rules="getValidationRules(field.key)" v-slot="{ errors }" :ref="'vp_' + field.key">
               <select v-model="form[field.key]" 
               class="w-full border border-gray-300 rounded px-3 py-2" 
               >
               <option disabled value="">{{ $t("select-an-option") }}</option>
               <option
                 v-for="opt in field.choices"
                 :key="opt.value"
                 :value="opt.value"
               >
                 {{ $t(opt.display_name) }}
               </option>
             </select>
             <span v-if="errors.length" class="text-red-500 text-xs">{{ $t('this-field-is-required')}}</span>
            </ValidationProvider>
             </div>
             
   
             <div v-else-if="field.kind === 'text'" class="text-sm leading-5 pt-4  rounded">
               <label>{{ checkLabel(field.label) }}
                <span v-if="getValidationRules(field.key).includes('required')" class="text-red-500">*</span>
               </label>
               <ValidationProvider  :name="field.label"  :rules="getValidationRules(field.key)" v-slot="{ errors }" :ref="'vp_' + field.key">
               <input
                 type="text"
                 v-model="form[field.key]"
                 :placeholder="field.placeholder || ''"
                 :disabled="field.key === 'pid_country'"
                 class="w-full border border-gray-300 rounded px-3 py-2"
               />
               <span v-if="errors.length" class="text-red-500 text-xs">{{ $t('this-field-is-required')}} <p></p>{{ $t('special-characters-not-allowed') }}</span>
              </ValidationProvider>
             </div>
   
             <div v-else-if="field.kind === 'checkbox'" class="text-sm leading-5 pt-4">
               <label>
                 <input type="checkbox" v-model="form[field.key]" />
                 <span v-html="checkLabel(field.label)"></span>
               </label>
             </div>
           </div>
   
   
           <!-- Finish Button -->
           <div class="mt-10 flex justify-end">
             <button @click="submitForm"  :disabled="isDisabled" class="finish-button rounded hover:bg-blue-700">
               {{$t("Finish") }}
             </button>
           </div>
         </div>
       </div>
       <div v-else class="text-center py-10">
         Loading countries...
       </div>
     </ValidationObserver>
   </div>
   </div>
   </template>
   
   <script>
   import Form from "@/views/register/Form";
   import store from "@/store";
   import { mapGetters } from "vuex";
   import Cookie from "js-cookie";
   import Header from "@/components/Header";
   import Vue from "vue";
   import VueI18Next from "@panter/vue-i18next";
   import i18next from "i18next";
   import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
   import { required, regex } from 'vee-validate/dist/rules';

   extend('required', required);
   extend('regex', regex);
   extend('unicodeSafe', {
    validate(value) {
        const pattern = /^[\p{L}\p{N}\s@._-]*$/u;
        return pattern.test(value);
    },
    message: 'This field contains invalid characters.'
    });
        
   Vue.use(VueI18Next);
   const i18n = new VueI18Next(i18next);
   
   export default {
     name: "TaxDetails",
     components: {
       Header,
       Form,
       ValidationObserver,
       ValidationProvider,
     },
     data() {
       return {
   
         form: {
            country: "",
            tax1_resident: "",
            tin:"",
            pid:"",
            pid_country:"",
            no_tin1:"",
            tax1_identification:"",
            tax_resident: "", 
            add_country2: false, 
            add_country3: false, 
            tin1:"",
            tin2:"",
            tin3:"",
            no_tin:"",
            no_tin2:"",
            no_tin3:"",
            tin_reason:"",
            tin1_reason:"",
            tin2_reason:"",
            tin3_reason:"",
            tax_identification:"",
            tax2_identification:"",
            tax3_identification:"",
            addr_country2:"",
            addr_country3:"",
            addr_country1:"",
            
         },
         isDisabled: false,
         cachedStepMeta: [],
         loadingCountries: true,
         
       };
     },
     computed: {
       ...mapGetters(["get_profile", "get_profile_options"]),
       
       current_step() {
       if (!localStorage.getItem("step")) {
         localStorage.setItem("step", "0");
       }
       return this.$store.getters.show_next_step;
     },
     visibleFields() {
     if (!this.cachedStepMeta.length) return [];
     return this.cachedStepMeta[0]?.filter(this.isFieldVisible);
   },
   
   countries() {
       return this.$store.getters.get_countries || [];
     },
   
     getUserData() {
         return this.$store.getters.get_user_data;
       },
     },
     methods: {
       isFieldVisible(field) {
         if (!field.condition) return true;
         const { field: condField, operator, value } = field.condition;
         const actual = this.form[condField];
   
         switch (operator) {
           case "exact":
             return actual === value;
           case "not_equal":
             return actual !== value;
           case "in":
             return Array.isArray(value) && value.includes(actual);
           default:
             return true;
         }
       },
   
    //    isRequired(fieldKey) {
    //      return this.requiredFields.includes(fieldKey);
    //    },

       isRequired(fieldkey) {
            const requiredFields = [
                'tin',
                'no_tin1',
                'tin1_reason',

                'addr_country1',
                'tax_identification',
                'tin1',
                'no_tin',
                'tin_reason',

                'addr_country2',
                'tax2_identification',
                'tin2',
                'no_tin2',
                'tin2_reason',

                'addr_country3' ,
                'tax3_identification',
                'tin3',
                'no_tin3',
                'tin3_reason',
            ];
            return this.requiredFields.includes(fieldkey);
        },
   
       async submitForm() {
         //if (this.isDisabled) return; // Prevent multiple clicks immediately
         const isValid = await this.$refs.observer.validate();
         if (!isValid) return;
   
         this.isDisabled = true;
   
         // Clean empty/null values from form
         const cleanedData = Object.fromEntries(
           Object.entries(this.form).filter(([_, v]) => v !== "" && v !== null)
         );
   
         const payload = cleanedData;
   
         this.$store
           .dispatch("tax_details", payload)
           .then(() => {
             // Refresh user profile
             this.$store.dispatch("profile");
   
             // Show modal if required for whitelabel
            //  if (process.env.VUE_APP_WHITELABEL === "ICMMU") {
            //    this.$store.commit("SET_ICM_PROOF_MODAL", "ID Proof");
            //  }
   
             // Redirect user based on suitability
             if (this.$store.getters.get_suitable?.result) {
               this.$router.replace("/");
             } else {
               this.$router.replace("/account-summary");
             }
   
             // Show success notification
             this.$notify({
               group: "foo",
               text: $t("your-tax-details-submitted-successfully"),
               type: "success",
             });
           })
           .catch((err) => {
             //this.isDisabled = false; //  Only re-enable on error
             // Show warning notification
             this.$notify({
               group: "foo",
               text:
                 err?.response?.data?.detail ||
                 $t("failed-to-submit-tax-details"),
               type: "warn",
             });
           })
           .finally(() => {
             this.isDisabled = false;
           });
   },
   
       generateStepMeta() {
       const t = this.$t.bind(this);
       const countryChoices = (this.$store.getters.get_countries || []).map(c => ({
         value: c.iso_code,
         display_name: c.name
       }));
   
       return [
        [
            {
                kind: "title",
                type: "title",
                title: t("tax-details"),
                subtitle: t("we-are-required-to-collect-tax-residency-info"),
            },
            {
                key:"tax1_resident",
                label: t("do-you-have-a-tax-identification-number"),
                kind: "select",
                type: "select",
                field:"tax1_resident",
                fieldId:"tax1_resident",
                placeholder: t("do-you-have-a-tax-identification-number"),
                needed:true,

                choices: [
                { value: "yes", display_name: t("Yes") },
                { value: "no", display_name: t("No") },
                ],
            },
            {
                key: "tin",
                label: t("enter-your-tax-identification-number"),
                kind: "text",
                type: "text",
                field:"tin",
                fieldId:"tin",
                placeholder:t("enter-your-tax-identification-number"),
                needed:true,
                condition: { field: "tax1_resident", operator: "exact", value: "yes" },
            },
            {
                key: "pid",
                label: t("please-provide-your-passport-id-number"),
                kind: "text",
                type: "text",
                field:"pid",
                fieldId:"pid",
                placeholder:t("please-provide-your-passport-id-number"),
                needed:true,
                condition: { field: "tax1_resident", operator: "exact", value: "no" },
            },
            {
                key: "no_tin1",
                label: t("please-tell-us-why-dont-have-a-tin"),
                kind: "select",
                type: "select",
                field:"no_tin1",
                fieldId:"no_tin1",
                placeholder:t("please-tell-us-why-dont-have-a-tin"),
                needed:true,
                condition: { field: "tax1_resident", operator: "exact", value: "no" },
                choices: [
                { value: "A", display_name: t("the-country-doesnt-issue-tins") },
                { value: "B", display_name: t("i-cant-get-a-tin") },
                { value: "C", display_name: t("the-country-doesnt-require-a-tin") },
                ],
            },
            {
                key: "tin1_reason",
                label: t("please-explain-why-you-cant-get-a-tin"),
                kind: "text",
                type: "text",
                field:"tin1_reason",
                fieldId:"tin1_reason",
                placeholder:t("please-explain-why-you-cant-get-a-tin"),
                needed:true,
                condition: { field: "no_tin1", operator: "exact", value: "B" },
            },
            {
                key: "tax_resident",
                label: t("are-you-a-tax-resident-in-any-country"),
                kind: "select",
                type: "select",
                field:"tax_resident",
                fieldId:"tax_resident",
                placeholder:t("are-you-a-tax-resident-in-any-country"),
                needed:true,
                choices: [
                { value: "yes", display_name:t( "Yes") },
                { value: "no", display_name: t("No") },
                ],
            },
            {
                key: "addr_country1",
                label:t("country-1"),
                field: "addr_country1",
                fieldId: "addr_country1",
                kind: "select",
                type: "select",
                placeholder: t('country-1'),
                needed: true,
                choices: countryChoices,
                condition: { field: "tax_resident", operator: "exact", value: "yes" },
            },
            {
                key: "tax_identification",
                label: t("do-you-have-a-tax-identification-number1"),
                kind: "select",
                type: "select",
                field:"tax_identification",
                fieldId:"tax_identification",
                placeholder:t("do-you-have-a-tax-identification-number1"),
                needed:true,
                condition: { field: "tax_resident", operator: "exact", value: "yes" },
                choices: [
                { value: "yes", display_name: t("Yes") },
                { value: "no", display_name: t("No") },
                ],
            },
            {
                key: "tin1",
                label: t("enter-your-tax-identification-1"),
                kind: "text",
                type: "text",
                field:"tin1",
                fieldId:"tin1",
                placeholder:t("enter-your-tax-identification-1"),
                needed:true,
                condition: { field: "tax_identification", operator: "exact", value: "yes" },
            },
            {
                key: "no_tin",
                label: t("please-tell-us-why-dont-have-a-tin1"),
                kind: "select",
                type: "select",
                field:"no_tin",
                fieldId:"no_tin",
                placeholder:t("please-tell-us-why-dont-have-a-tin1"),
                needed:true,
                condition: { field: "tax_identification", operator: "exact", value: "no" },
                choices: [
                { value: "A", display_name: t("the-country-doesnt-issue-tins") },
                { value: "B", display_name: t("i-cant-get-a-tin") },
                { value: "C", display_name: t("the-country-doesnt-require-a-tin") },
                ],
            },
            {
                key: "tin_reason",
                label: t("please-explain-why-you-cant-get-a-tin1"),
                kind: "text",
                type: "text",
                field:"tin_reason",
                fieldId:"tin_reason",
                placeholder:t("please-explain-why-you-cant-get-a-tin1"),
                needed:true,
                condition: { field: "no_tin", operator: "exact", value: "B" },
            },

            {
                key: "add_country2",
                label: t("add-country-2"),
                kind: "checkbox",
                type: "checkbox",
                field: "add_country2",
                fieldId: "add_country2",
                needed: false,
                condition: { field: 'tax_resident', operator: 'exact', value: 'yes' }
            },
            {
                key: "addr_country2",
                label: t("country-2"),
                kind: "select",
                type: "select",
                placeholder: t('country-2'),
                country: true,
                field: "addr_country2",
                fieldId: "country",
                needed:true,
                choices: countryChoices,
                condition: { field: "add_country2", operator: "exact", value: true },
            },
            {
                key: "tax2_identification",
                label: t("do-you-have-a-tax-identification-number2"),
                kind: "select",
                type: "select",
                field:"tax2_identification",
                fieldId:"tax2_identification",
                placeholder:t("do-you-have-a-tax-identification-number2"),
                needed:true,
                condition: { field: "add_country2", operator: "exact", value: true },
                choices: [
                { value: "yes", display_name: t("Yes") },
                { value: "no", display_name: t("No") },
                ],
            },
            {
                key: "tin2",
                label:t("enter-your-tax-identification-2"),
                kind: "text",
                type: "text",
                field:"tin2",
                fieldId:"tin2",
                placeholder:t("enter-your-tax-identification-2"),
                needed:true,
                condition: { field: "tax2_identification", operator: "exact", value: "yes" },
            },
            {
                key: "no_tin2",
                label: t("please-tell-us-why-dont-have-a-tin2"),
                kind: "select",
                type: "select",
                field:"no_tin2",
                fieldId:"no_tin2",
                placeholder:t("please-tell-us-why-dont-have-a-tin2"),
                needed:true,
                condition: { field: "tax2_identification", operator: "exact", value: "no" },
                choices: [
                { value: "A", display_name: t("the-country-doesnt-issue-tins") },
                { value: "B", display_name: t("i-cant-get-a-tin") },
                { value: "C", display_name: t("the-country-doesnt-require-a-tin") },
                ],
            },
            {
                key: "tin2_reason",
                label:t("please-explain-why-you-cant-get-a-tin2"),
                kind: "text",
                type: "text",
                field:"tin2_reason",
                fieldId:"tin2_reason",
                placeholder:t("please-explain-why-you-cant-get-a-tin2"),
                needed:true,
                condition: { field: "no_tin2", operator: "exact", value: "B" },
            },

            {
                key: "add_country3",
                label:t("add-country-3"),
                kind: "checkbox",
                type: "checkbox",
                field: "add_country3",
                fieldId: "add_country3",
                needed: false,
                condition: { field: 'tax_resident', operator: 'exact', value: 'yes' }
            },
            {
                key: "addr_country3",
                label: t("country-3"),
                kind: "select",
                type: "select",
                field: "addr_country3",
                fieldId: "addr_country3",
                placeholder: t('country-3'),
                needed:true,
                choices: countryChoices,
                condition: { field: "add_country3", operator: "exact", value: true },
            },
            {
                key: "tax3_identification",
                label:t("do-you-have-a-tax-identification-number3"),
                kind: "select",
                type: "select",
                field:"tax3_identification",
                fieldId:"tax3_identification",
                placeholder:t("do-you-have-a-tax-identification-number3"),
                needed:true,
                condition: { field: "add_country3", operator: "exact", value: true },
                choices: [
                { value: "yes", display_name: t("Yes") },
                { value: "no", display_name: t( "No") },
                ],
            },
            {
                key: "tin3",
                label: t("enter-your-tax-identification-3"),
                kind: "text",
                type: "text",
                field:"tin3",
                fieldId:"tin3",
                placeholder:t("enter-your-tax-identification-3"),
                needed:true,
                condition: { field: "tax3_identification", operator: "exact", value: "yes" },
            },
            {
                key: "no_tin3",
                label: t("please-tell-us-why-dont-have-a-tin3"),
                kind: "select",
                type: "select",
                field:"no_tin3",
                fieldId:"no_tin3",
                placeholder:t("please-tell-us-why-dont-have-a-tin3"),
                needed:true,
                condition: { field: "tax3_identification", operator: "exact", value: "no" },
                choices: [
                { value: "A", display_name: t("the-country-doesnt-issue-tins") },
                { value: "B", display_name: t("i-cant-get-a-tin") },
                { value: "C", display_name: t("the-country-doesnt-require-a-tin") },
                ],
            },
            {
                key: "tin3_reason",
                label: t("please-explain-why-you-cant-get-a-tin3"),
                kind: "text",
                type: "text",
                field:"tin3_reason",
                fieldId:"tin3_reason",
                placeholder:t("please-explain-why-you-cant-get-a-tin3"),
                needed:true,
                condition: { field: "no_tin3", operator: "exact", value: "B" },
            },
         ]
       ]
       },
   
       checkLabel(label) {
         switch (label) {
           case "Country (1)":
             return i18n.t("country-1");
             break;
           case "Country (2)":
             return i18n.t("country-2");
             break;
           case "Country (3)":
             return i18n.t("country-3");
             break;
           case "Do you have a Tax Identification Number in your country of residence?":
             return i18n.t("do-you-have-a-tax-identification-number");
             break;
           case "Do you have a Tax Identification Number for Country (1) you listed?":
             return i18n.t("do-you-have-a-tax-identification-number1");
             break;
           case "Do you have a Tax Identification Number for Country (2) you listed?":
             return i18n.t("do-you-have-a-tax-identification-number2");
             break;
           case "Do you have a Tax Identification Number for Country (3) you listed?":
             return i18n.t("do-you-have-a-tax-identification-number3");
             break;
           case "Enter your Tax Identification Number":
             return i18n.t("enter-your-tax-identification-number");
             break;
           case "Enter your Tax Identification Number - Country (1)":
             return i18n.t("enter-your-tax-identification-1");
             break;
           case "Enter your Tax Identification Number - Country (2)":
             return i18n.t("enter-your-tax-identification-2");
             break;
           case "Enter your Tax Identification Number - Country (3)":
             return i18n.t("enter-your-tax-identification-3");
             break;
           case "Please tell us why you don't have a TIN:":
             return i18n.t("please-tell-us-why-dont-have-a-tin");
             break;
           case "Please tell us why you don't have a TIN (1)":
             return i18n.t("please-tell-us-why-dont-have-a-tin1");
             break;
           case "Please tell us why you don't have a TIN (2)":
             return i18n.t("please-tell-us-why-dont-have-a-tin2");
             break;
           case "Please tell us why you don't have a TIN (3)":
             return i18n.t("please-tell-us-why-dont-have-a-tin3");
             break;
           case "The country doesn't issue TINs":
             return i18n.t("the-country-doesnt-issue-tins");
             break;
           case "I can't get a TIN":
             return i18n.t("i-cant-get-a-tin");
             break;
           case "The country doesn't require a TIN":
             return i18n.t("the-country-doesnt-require-a-tin");
             break;
           case "Please explain why you can't get a TIN:":
             return i18n.t("please-explain-why-you-cant-get-a-tin");
             break;
           case "Please explain why you can't get a TIN (1)":
             return i18n.t("please-explain-why-you-cant-get-a-tin1");
             break;
           case "Please explain why you can't get a TIN (2)":
             return i18n.t("please-explain-why-you-cant-get-a-tin2");
             break;
           case "Please explain why you can't get a TIN (3)":
             return i18n.t("please-explain-why-you-cant-get-a-tin3");
             break;
           case "Add Another Country 2":
             return i18n.t("add-country-2");
             break;
           case "Add Another Country 3":
             return i18n.t("add-country-3");
             break;
           case "Your tax details submitted successfully":
             return i18n.t("your-tax-details-submitted-successfully");
             break;
           case "Failed to submit Tax Details. Please contact Support Team":
             return i18n.t("failed-to-submit-tax-details");
             break;

           case "Special characters (*,&,! etc) are not allowed":
             return i18n.t("special-characters-not-allowed");
             break;
           case "Please provide your Passport/ID Number":
             return i18n.t("please-provide-your-passport-id-number");
             break;
           case "Country of Residence":
             return i18n.t("country-of-residence");
             break;
   
           default:
             return label;
             break;
         }
       },
   
       checkTitle(title) {
         switch (title) {
           case "Tax details":
             return i18n.t("tax-details");
             break;
           default:
             return title;
             break;
         }
       },
   
       checkSubtitle(subtitle) {
         switch (subtitle) {
           case "We are required to collect tax residency information.":
             return i18n.t("we-are-required-to-collect-tax-residency");
           
           default:
             return subtitle;
         }
       },

       getValidationRules(fieldKey) {
        // Fields that are required but don't need special character validation 
        const requiredWithoutCharCheck = [
            'tin_reason',
            'tin1_reason',
            'tin2_reason',
            'tin3_reason'
        ];

        if (requiredWithoutCharCheck.includes(fieldKey)) {
            return 'required';  // required only, no unicodeSafe
        }
        // Fields that are always required
        const alwaysRequired = ['tax1_resident', 'tax_resident'];

        // Conditional rules
        const conditionalRules = {
            'tin': () => this.form.tax1_resident === 'yes',
            'pid': () => this.form.tax1_resident === 'no',
            'no_tin1': () => this.form.tax1_resident === 'no',
            'tin1_reason': () => this.form.no_tin1 === 'B' && this.form.tax1_resident ==='no',

            'addr_country1': () => this.form.tax_resident === 'yes',
            'tax_identification': () => this.form.tax_resident === 'yes',
            'tin1': () => this.form.tax_identification === 'yes',
            'no_tin': () => this.form.tax_identification === 'no',
            'tin_reason': () => this.form.no_tin === 'B',

            'addr_country2': () => this.form.add_country2,
            'tax2_identification': () => this.form.add_country2,
            'tin2': () => this.form.tax2_identification === 'yes',
            'no_tin2': () => this.form.tax2_identification === 'no',
            'tin2_reason': () => this.form.no_tin2 === 'B',

            'addr_country3': () => this.form.add_country3,
            'tax3_identification': () => this.form.add_country3,
            'tin3': () => this.form.tax3_identification === 'yes',
            'no_tin3': () => this.form.tax3_identification === 'no',
            'tin3_reason': () => this.form.no_tin3 === 'B',
        };

        const isConditionallyRequired = conditionalRules[fieldKey]?.();

        if (alwaysRequired.includes(fieldKey) || isConditionallyRequired) {
            return 'required|unicodeSafe';
            }
        return 'unicodeSafe';
                

        // if (alwaysRequired.includes(fieldKey) || isConditionallyRequired) {
        //   return 'required|regex:/^[\\p{L}\\p{N}\\s\\-_@.]*$/u';
        // }

        // // If not required but still validate content format (if filled)
        // return 'regex:/^[\\p{L}\\p{N}\\s\\-_@.]*$/u';
        },
        refreshValidation(fieldKey) {
            const provider = this.$refs[`vp_${fieldKey}`];
            if (provider && provider.validate) {
                provider.validate();
            }
        }
     },
     async mounted() {
        //get profile country
      if (this.get_profile?.address?.addr_country) {
          this.form.pid_country = this.get_profile.address.addr_country;
        }
     
     // Fetch countries first
     await this.$store.dispatch("countries");
   
     Object.assign(this.form, this.$store.getters.get_user_data || {});
   
     // Fetch user profile before generating fields
     try {
       await this.$store.getters.get_profile; // assumes this sets `get_profile`
       const userProfile = this.get_profile || {};
   
       console.log(this.get_profile);
   
   
       // Merge non-empty fields from profile into form
       this.form = {
         ...this.form,
         ...userProfile.data, // assuming profile.data contains TIN/country info
       };
     } catch (err) {
       console.error("Failed to load profile data:", err);
     }
   
     this.cachedStepMeta = this.generateStepMeta();

     const watchedFields = [
        'tax1_resident',
        'no_tin1',
        'tin',
        'pid',
        'tin1_reason',
        'addr_country1',
        'tax_identification',
        'tin1',
        'no_tin',
        'tin_reason',
        'addr_country2',
        'tax2_identification',
        'tin2',
        'no_tin2',
        'tin2_reason',
        'addr_country3',
        'tax3_identification',
        'tin3',
        'no_tin3',
        'tin3_reason',
      ];

      watchedFields.forEach((fieldKey) => {
        this.$watch(`form.${fieldKey}`, () => {
          this.refreshValidation(fieldKey);
        });
      });
   },
     created() {
       this.$store.dispatch("countries").then(() => {
       this.cachedStepMeta = this.generateStepMeta();
       this.loadingCountries = false;
     });
     this.form = {
       ...this.form, // preserve structure
       ...this.$store.getters.get_user_data // populate with backend data
     };
     },

     watch: {
     '$store.getters.get_countries'(newVal) {
       if (newVal && newVal.length > 0) {
         this.cachedStepMeta = this.generateStepMeta();
         this.loadingCountries = false;
       }
     },

     get_profile: {
      handler(newVal) {
        if (newVal?.address?.addr_country) {
          this.form.pid_country = newVal.address.addr_country;
        }
      },
      immediate: true, 
      deep: true
    },
   
     'form.add_country2'(val) {
       if (val == false){
         
         this.form.tin2 = '';
         this.form.no_tin2 = '';
         this.form.tin2_reason = '';
         this.form.addr_country2 = '';
         
       }
     },
   
     'form.add_country3'(val) {
       if (val == false){
       
         this.form.tin3 = '';
         this.form.no_tin3 = '';
         this.form.tin3_reason = '';
         this.form.addr_country3 = '';
       }
     },
   
     'form.tax_resident'(val) {
        if (val === 'no') {
            this.form.tax_identification = '';
            this.form.tax2_identification = '';
            this.form.tax3_identification = '';
            this.form.tin1 = '';
            this.form.tin2 = '';
            this.form.tin3 = '';
            this.form.no_tin = '';
            this.form.no_tin2 = '';
            this.form.no_tin3 = '';
            this.form.tin_reason = '';
            this.form.tin2_reason = '';
            this.form.tin3_reason = '';
            this.form.addr_country2 = '';
            this.form.addr_country3 = '';
            this.form.addr_country1 = '';
            this.form.add_country2 = false;
            this.form.add_country3 = false;
        }

        if (String(val).toLowerCase() !== 'yes') {
            const taxKeys = Object.keys(this.form).filter((key) => {
                const shouldMatch =
                key.includes('addr_country2') ||
                key.includes('addr_country3') ||
                key.includes('addr_country1') ||
                (key.includes('tax') && key.includes('identification')) ||
                key.includes('tax2_identification') ||
                key.includes('tax3_identification') ||
                key.includes('tin_reason') ||
                key.includes('tin2_reason') ||
                key.includes('tin3_reason') ||
                key.includes('no_tin') ||
                key.includes('no_tin2') ||
                key.includes('no_tin3') ||
                key.includes('tin1') ||
                key.includes('tin2') ||
                key.includes('tin3');

                // Explicitly exclude these two
                const explicitlyExcluded = ['no_tin1', 'tin1_reason'];

                return shouldMatch && !explicitlyExcluded.includes(key);
            });

            taxKeys.forEach((key) => {
                this.form[key] = '';
            });
            }

        },
   
       'form.tax1_resident'(val) {
            if (val === 'no') {
                // Clear TIN and reason if user is not a tax resident
                this.form.tin = '';
                this.form.tin1_reason = '';
            }

            if (val === 'yes') {
                // Clear no_tin1 and reason if user is a tax resident
                this.form.no_tin1 = '';
                this.form.pid = '';
                this.form.tin1_reason = '';
            }

            // If value is not 'yes', clear all 'tin' related fields
            if (String(val).toLowerCase() !== 'yes') {
                const taxKeys = Object.keys(this.form).filter(
                (key) => key.includes('tin')
                );
                taxKeys.forEach(key => {
                this.form[key] = '';
                });
            }
            },

        'form.no_tin1'(newVal) {
            if (newVal !== 'B') {
            this.form.tin1_reason = '';
            }
        },
        
        'form.no_tin'(newVal) {
            if (newVal !== 'B') {
            this.form.tin_reason = '';
            }
        },

        'form.no_tin2'(newVal) {
            if (newVal !== 'B') {
            this.form.tin2_reason = '';
            }
        },
        'form.no_tin3'(newVal) {
            if (newVal !== 'B') {
            this.form.tin3_reason = '';
            }
        },

        'form.tax_identification'(val) {
            if (val === 'yes') {
                this.form.no_tin = '';
                this.form.tin_reason = '';
            }

            if (val === 'no') {
                this.form.tin1 = '';
                this.form.no_tin = '';
            }
        },
        'form.tax2_identification'(val) {
            if (val === 'yes') {
                this.form.no_tin2 = '';
                this.form.tin2_reason = '';
            }

            if (val === 'no') {
                this.form.tin2 = '';
                this.form.no_tin2 = '';
            }
        },

        'form.tax3_identification'(val) {
            if (val === 'yes') {
                this.form.no_tin3 = '';
                this.form.tin3_reason = '';
            }

            if (val === 'no') {
                this.form.tin3 = '';
                this.form.no_tin3 = '';
            }
        },

   }
    
   };
   </script>
   
   <style scoped>
   label {
     display: block;
     margin-top: 1rem;
     font-weight: 500;
   }
   select,
   input[type="text"] {
     display: block;
     margin-top: 0.3rem;
     padding: 0.5rem;
     width: 100%;
     max-width: 500px;
     border-width: 1px;
   }
   .finish-button {
     background-color: #1e88e5;
     color: white;
     padding: 0.7rem 1.5rem;
     border: none;
     border-radius: 4px;
     font-weight: bold;
     cursor: pointer;
   }
   .finish-button:hover {
     background-color: #1565c0;
   }
   </style>
   